var map = {
	"./amex.svg": "7ec4",
	"./applepay.svg": "70f2",
	"./directdebit_sepa.svg": "fcf1",
	"./giropay.svg": "d102",
	"./klarna.svg": "b67b",
	"./master.svg": "5a23",
	"./paydirekt.svg": "671f",
	"./payone.svg": "7662",
	"./paypal.svg": "130b",
	"./sofortueberweisung.svg": "1686",
	"./visa.svg": "6b2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fc1";